import React from 'react'
import PropTypes from 'prop-types'
import { showModal } from './DomHandler'

class ServiceCheck extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      trigger: false,
      code: false,
      isValidCode: false,
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(event) {
    this.setState({ code: event.target.value })
  }

  handleSubmit(event) {
    event.preventDefault()
    this.checkCode()
    showModal()
  }

  checkCode() {
    let isValidZip = false
    const { data } = this.props
    const { code } = this.state

    if (data.validCodes.indexOf(code) >= 0) isValidZip = true

    data.expressServices.map(el => {
      if (el.zip_codes.indexOf(code) >= 0) isValidZip = true
    })

    this.setState({ isValidCode: isValidZip })
  }

  renderResultsModal() {
    const { data, strings } = this.props

    let modalBody = this.state.isValidCode ? (
      <div className="modal-body">
        <p>
          {strings.text.replace('%s', this.state.code ? this.state.code : '')}
        </p>
        <ul className="service-check__services-list list-unstyled">
          <h3>{strings.expressTitle}</h3>
          {data.expressServices.map((el, i) => (
            <li key={i}>
              {el.zip_codes.indexOf(this.state.code) >= 0 ? (
                <p className="service-check__service service-check__service--correct big">
                  {el.service}
                </p>
              ) : (
                <p className="service-check__service service-check__service--wrong big">
                  {el.alternative_text}
                </p>
              )}
            </li>
          ))}
        </ul>
        <ul className="service-check__services-list list-unstyled">
          <h3>{strings.thermoMedTitle}</h3>
          <li>
            {data.thermoMedServices.zip_codes.indexOf(this.state.code) < 0 ? (
              <p className="service-check__service service-check__service--correct big">
                {data.thermoMedServices.service}
              </p>
            ) : (
              <p className="service-check__service service-check__service--wrong big">
                {data.thermoMedServices.alternative_text}
              </p>
            )}
          </li>
        </ul>
      </div>
    ) : (
      <div className="modal-body">
        <p className="text-center big">
          {strings.invalidCode} - {this.state.code}
        </p>
      </div>
    )
    return (
      <div
        className="service-check__modal modal fade"
        id="service-check-modal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div className="modal-content">
            {modalBody}
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-lg btn-secondary"
                data-dismiss="modal"
              >
                {strings.buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { strings } = this.props
    const { code } = this.state

    console.log(this.props) // eslint-disable-line

    return (
      <form
        className="service-check__form form-inline"
        onSubmit={this.handleSubmit}
      >
        <div className="input-group input-group-lg mb-3">
          <input
            type="text"
            pattern="[0-9]{5}"
            required={true}
            className="form-control"
            placeholder={strings.placeholder}
            value={code ? code : ''}
            onChange={this.handleChange}
          />
          <div className="input-group-append">
            <button
              className="btn btn-primary service-check__form-submit"
              type="submit"
            >
              <i className="btb bt-arrow-right" />
            </button>
          </div>
        </div>
        {this.renderResultsModal()}
      </form>
    )
  }
}

ServiceCheck.propTypes = {
  data: PropTypes.object,
  strings: PropTypes.object,
}

export default ServiceCheck
